import { Typography } from '@ui/uikit/components/common/Typography';

interface MyResultCardProps {
  label: string;
  value: string | number;
  isLoading: boolean;
}

export const MyResultCard = ({ label, value, isLoading }: MyResultCardProps) => (
  <div className="flex flex-col gap-2 items-start p-4 pb-3 h-[84px] border border-base-border-medium rounded-xl flex-1 text-left w-full xl-msq:w-[194px] 3xl-msq:w-[216px]">
    {isLoading ? (
      <>
        <div className="msq-skeleton-text w-full max-w-10 h-4" />
        <div className="msq-skeleton-text w-full max-w-20 h-4" />
      </>
    ) : (
      <>
        <Typography variant="caption-xs" color="tertiary" isEllipsis isFullWidth title={label}>
          {label}
        </Typography>
        <Typography variant="h3" isEllipsis isFullWidth title={value.toString()}>
          {value}
        </Typography>
      </>
    )}
  </div>
);
